import api from '@/services/api-service'

export const postRefund = (userSubscriptionId, dto) => {
  return api().post(`/refunds/${userSubscriptionId}`, dto)
}
